/* ELEGANCE LUXE — theme JS: pill nav glow, mobile menu, reveals,
   scroll film, product gallery, quantity steppers. No dependencies. */
(function () {
  "use strict";

  var reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* Pill nav sliding glow */
  function initNav() {
    var nav = document.querySelector(".ee-nav");
    if (!nav) return;
    var glow = nav.querySelector(".ee-nav__glow");
    if (!glow) {
      glow = document.createElement("span");
      glow.className = "ee-nav__glow";
      glow.setAttribute("aria-hidden", "true");
      nav.appendChild(glow);
    }
    var active = nav.querySelector(".ee-nav__link--active");

    function moveTo(link) {
      if (!link) { glow.classList.remove("ee-nav__glow--on"); return; }
      var m = nav.getBoundingClientRect();
      var r = link.getBoundingClientRect();
      glow.style.left = (r.left - m.left) + "px";
      glow.style.width = r.width + "px";
      glow.classList.add("ee-nav__glow--on");
    }
    function rest() { moveTo(active || null); }

    nav.querySelectorAll(".ee-nav__link").forEach(function (link) {
      link.addEventListener("mouseenter", function () { moveTo(link); });
      link.addEventListener("focus", function () { moveTo(link); });
    });
    nav.addEventListener("mouseleave", rest);
    window.addEventListener("resize", rest);
    rest();
  }

  /* Mobile menu */
  function initMobileMenu() {
    var btn = document.querySelector("[data-ee-menu-toggle]");
    var menu = document.querySelector("[data-ee-mobile-menu]");
    if (!btn || !menu) return;
    btn.addEventListener("click", function () {
      var open = menu.classList.toggle("ee-mobile-menu--open");
      btn.setAttribute("aria-expanded", open ? "true" : "false");
    });
  }

  /* Gentle reveals */
  function initReveals() {
    if (reducedMotion || !("IntersectionObserver" in window)) return;
    var targets = document.querySelectorAll(".ee-card, .ee-tile, .ee-newsletter__box, .ee-story__inner");
    if (!targets.length) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add("ee-in"); io.unobserve(e.target); }
      });
    }, { rootMargin: "0px 0px -8% 0px", threshold: 0.08 });
    targets.forEach(function (t, i) {
      if (t.getBoundingClientRect().top > window.innerHeight * 0.9) {
        t.classList.add("ee-reveal");
        t.style.transitionDelay = (i % 4) * 60 + "ms";
        io.observe(t);
      }
    });
  }

  /* Scroll-driven film */
  function initScrollFilm() {
    document.querySelectorAll("[data-ee-film]").forEach(function (wrap) {
      var video = wrap.querySelector("video");
      if (!video) return;
      video.muted = true;
      video.playsInline = true;

      if (reducedMotion) {
        video.loop = true;
        var p = video.play();
        if (p && p.catch) p.catch(function () {});
        return;
      }

      var duration = 0, target = 0, current = 0, raf = null;

      function measure() {
        var rect = wrap.getBoundingClientRect();
        var total = rect.height - window.innerHeight;
        if (total <= 0) return 0;
        return Math.min(1, Math.max(0, -rect.top / total));
      }
      function tick() {
        raf = null;
        if (!duration) return;
        current += (target - current) * 0.14;
        if (Math.abs(target - current) < 0.002) current = target;
        try { video.currentTime = current; } catch (e) {}
        if (current !== target) raf = requestAnimationFrame(tick);
      }
      function onScroll() {
        if (!duration) return;
        target = measure() * duration;
        if (!raf) raf = requestAnimationFrame(tick);
      }
      function ready() {
        duration = Math.max(0, video.duration - 0.05);
        video.pause();
        onScroll();
      }
      if (video.readyState >= 1) ready();
      else video.addEventListener("loadedmetadata", ready);
      video.load();
      window.addEventListener("scroll", onScroll, { passive: true });
      window.addEventListener("resize", onScroll);
    });
  }


  /* Wrap any table inside page/policy rich text in a scroll container, so a
     wide shipping or returns table scrolls on its own instead of forcing the
     whole page sideways on mobile. */
  function initTables() {
    document.querySelectorAll(".ee-page-content table, .ee-rte table").forEach(function (t) {
      if (t.parentElement && t.parentElement.classList.contains("ee-table-scroll")) return;
      var wrap = document.createElement("div");
      wrap.className = "ee-table-scroll";
      t.parentNode.insertBefore(wrap, t);
      wrap.appendChild(t);
    });
  }

  /* Product gallery thumbs */
  function initGallery() {
    document.querySelectorAll("[data-ee-gallery]").forEach(function (g) {
      var main = g.querySelector("[data-ee-gallery-main]");
      g.querySelectorAll("[data-ee-thumb]").forEach(function (thumb) {
        thumb.addEventListener("click", function () {
          main.src = thumb.dataset.eeThumb;
          main.srcset = "";
          g.querySelectorAll("[data-ee-thumb]").forEach(function (t) { t.classList.remove("is-active"); });
          thumb.classList.add("is-active");
        });
      });
    });
  }

  /* Quantity steppers */
  function initQty() {
    document.querySelectorAll(".ee-qty").forEach(function (q) {
      var input = q.querySelector("input");
      q.querySelectorAll("button").forEach(function (btn) {
        btn.addEventListener("click", function () {
          var v = parseInt(input.value, 10) || 1;
          v += btn.dataset.eeQty === "up" ? 1 : -1;
          input.value = Math.max(parseInt(input.min, 10) || 0, v);
          input.dispatchEvent(new Event("change", { bubbles: true }));
        });
      });
    });
  }

  /* Dark mode toggle */
  function initThemeToggle() {
    document.querySelectorAll("[data-ee-theme-toggle]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var root = document.documentElement;
        var isDark = root.getAttribute("data-ee-theme") === "dark";
        if (isDark) root.removeAttribute("data-ee-theme");
        else root.setAttribute("data-ee-theme", "dark");
        try { localStorage.setItem("ee-theme", isDark ? "light" : "dark"); } catch (e) {}
      });
    });
  }

  /* Sticky header: Shopify wraps sections in a div, which breaks
     position:sticky on the header itself — make the WRAPPER sticky. */
  function initStickyHeader() {
    var header = document.querySelector(".ee-header");
    if (!header) return;
    var wrap = header.closest(".shopify-section") || header.parentElement;
    if (wrap && wrap !== document.body) {
      wrap.style.position = "sticky";
      wrap.style.top = "0";
      wrap.style.zIndex = "60";
    }
    var onScroll = function () {
      header.classList.toggle("ee-header--stuck", window.scrollY > 4);
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
  }

  /* ---------- Wishlist (localStorage) ---------- */
  function wlRead() {
    try {
      var raw = JSON.parse(localStorage.getItem("ee-wishlist"));
      if (!Array.isArray(raw)) return [];
      // Storage is attacker-writable (extensions, shared machines, an earlier
      // XSS). Keep only well-formed entries and cap the size.
      return raw.filter(function (x) {
        return x && typeof x === "object" && typeof x.h === "string" && x.h.length < 256;
      }).slice(0, 200);
    } catch (e) { return []; }
  }
  function wlWrite(list) {
    try { localStorage.setItem("ee-wishlist", JSON.stringify(list)); } catch (e) {}
    wlCounts(list);
  }
  function wlCounts(list) {
    list = list || wlRead();
    document.querySelectorAll("[data-ee-wish-count]").forEach(function (el) {
      el.textContent = list.length;
      el.style.display = list.length ? "flex" : "none";
    });
  }
  function wlHas(handle) {
    return wlRead().some(function (x) { return x.h === handle; });
  }
  function wlMark(btn) {
    var active = wlHas(btn.dataset.eeHandle);
    btn.classList.toggle("is-active", active);
    btn.setAttribute("aria-pressed", active ? "true" : "false");
    var label = btn.querySelector(".ee-wish-label");
    if (label) label.textContent = active ? "In your wishlist" : "Add to wishlist";
  }
  function initWishlist() {
    document.querySelectorAll("[data-ee-wish]").forEach(function (btn) {
      wlMark(btn);
      if (btn.dataset.eeWishBound) return;
      btn.dataset.eeWishBound = "1";
      btn.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        var list = wlRead();
        var h = btn.dataset.eeHandle;
        if (list.some(function (x) { return x.h === h; })) {
          list = list.filter(function (x) { return x.h !== h; });
        } else {
          list.push({
            h: h,
            t: btn.dataset.eeTitle || "",
            u: btn.dataset.eeUrl || "#",
            i: btn.dataset.eeImage || "",
            p: btn.dataset.eePrice || ""
          });
        }
        wlWrite(list);
        wlDrawerRender();
        document.querySelectorAll('[data-ee-wish][data-ee-handle="' + h + '"]').forEach(wlMark);
        renderWishlistPage();
      });
    });
    wlCounts();
    renderWishlistPage();
  }
  function renderWishlistPage() {
    var box = document.querySelector("[data-ee-wishlist-items]");
    if (!box) return;
    var empty = document.querySelector("[data-ee-wishlist-empty]");
    var list = wlRead();
    if (!list.length) {
      box.innerHTML = "";
      if (empty) empty.style.display = "block";
      return;
    }
    if (empty) empty.style.display = "none";
    box.innerHTML = list.map(function (x) {
      var url = safeUrl(x.u);
      var img = x.i ? safeUrl(x.i) : "";
      return '<div class="ee-card">' +
        '<a href="' + esc(url) + '" class="ee-card__media">' +
        (img ? '<img src="' + esc(img) + '" alt="" loading="lazy">' : "") +
        "</a>" +
        '<div class="ee-card__info">' +
        '<h3 class="ee-card__title"><a href="' + esc(url) + '">' + esc(x.t) + "</a></h3>" +
        '<div class="ee-price"><span>' + esc(x.p) + "</span></div>" +
        '<button class="ee-link ee-wish-remove" data-ee-wish-remove="' + esc(x.h) + '">Remove</button>' +
        "</div></div>";
    }).join("");
    box.querySelectorAll("[data-ee-wish-remove]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        wlWrite(wlRead().filter(function (x) { return x.h !== btn.dataset.eeWishRemove; }));
        document.querySelectorAll('[data-ee-wish][data-ee-handle="' + btn.dataset.eeWishRemove + '"]').forEach(wlMark);
        renderWishlistPage();
      });
    });
  }



  /* ---------- Output escaping ----------
     Everything below builds markup with innerHTML from values that came out of
     localStorage or a JSON endpoint. Concatenating those straight into HTML
     lets a crafted title or URL execute script, so every interpolated value is
     escaped, and every URL is checked to be a same-origin relative path before
     it is used as href or src. */
  function esc(v) {
    return String(v == null ? "" : v)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;");
  }

  function safeUrl(v) {
    var u = String(v == null ? "" : v).trim();
    // Relative paths only, and never a protocol-relative "//evil.com".
    if (u.charAt(0) === "/" && u.charAt(1) !== "/") return u;
    // Allow absolute URLs that stay on this store, plus Shopify's CDN images.
    try {
      var parsed = new URL(u, window.location.origin);
      if (parsed.protocol !== "http:" && parsed.protocol !== "https:") return "#";
      if (parsed.hostname === window.location.hostname) return parsed.href;
      if (/(^|\.)shopify\.com$/.test(parsed.hostname) || /(^|\.)shopifycdn\.com$/.test(parsed.hostname)) return parsed.href;
    } catch (e) {}
    return "#";
  }

  /* ---------- Wishlist drawer ----------
     The header heart used to link straight to /pages/wishlist. That page has to
     be created by hand in the Shopify admin — a theme cannot create pages — so
     on any store where it was never made, the heart returned a 404. The heart
     now opens this drawer instead, which is part of the theme and therefore
     always exists. The standalone /pages/wishlist page still works if created. */
  function wlDrawerRender() {
    var box = document.querySelector("[data-ee-wish-drawer-items]");
    if (!box) return;
    var list = wlRead();
    if (!list.length) {
      box.innerHTML = '<p class="ee-wish-drawer__empty">Nothing saved yet. Tap the heart on any product to keep it here.</p>';
      return;
    }
    box.innerHTML = list.map(function (x) {
      var url = safeUrl(x.u);
      var img = x.i ? safeUrl(x.i) : "";
      return '<div class="ee-wish-row">' +
        '<a href="' + esc(url) + '" class="ee-wish-row__img">' +
        (img ? '<img src="' + esc(img) + '" alt="" loading="lazy">' : "") + "</a>" +
        '<div class="ee-wish-row__info">' +
        '<a href="' + esc(url) + '">' + esc(x.t) + "</a>" +
        '<div class="ee-price"><span>' + esc(x.p) + "</span></div>" +
        '<button class="ee-link" data-ee-wish-remove="' + esc(x.h) + '">Remove</button>' +
        "</div></div>";
    }).join("");
    box.querySelectorAll("[data-ee-wish-remove]").forEach(function (b) {
      b.addEventListener("click", function () {
        wlWrite(wlRead().filter(function (x) { return x.h !== b.dataset.eeWishRemove; }));
        document.querySelectorAll('[data-ee-wish][data-ee-handle="' + b.dataset.eeWishRemove + '"]').forEach(wlMark);
        wlDrawerRender();
        renderWishlistPage();
      });
    });
  }

  function initWishDrawer() {
    var drawer = document.querySelector("[data-ee-wish-drawer]");
    if (!drawer || drawer.dataset.eeBound) return;
    drawer.dataset.eeBound = "1";

    function open(e) {
      if (e) e.preventDefault();
      wlDrawerRender();
      drawer.classList.add("is-open");
      document.body.style.overflow = "hidden";
    }
    function close() {
      drawer.classList.remove("is-open");
      document.body.style.overflow = "";
    }

    document.addEventListener("click", function (e) {
      var a = e.target.closest('a[href*="/pages/wishlist"], [data-ee-wish-open]');
      if (a) open(e);
    });
    drawer.querySelectorAll("[data-ee-wish-close]").forEach(function (b) {
      b.addEventListener("click", close);
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") close();
    });
  }


  /* ---------- Collection filters ---------- */
  function initFilters() {
    var form = document.querySelector("[data-ee-filter-form]");
    var main = document.querySelector(".ee-shop__main");

    // Ticking a box applies immediately, the way large storefronts behave.
    if (form && !form.dataset.eeBound) {
      form.dataset.eeBound = "1";
      form.addEventListener("change", function (e) {
        if (e.target.matches("[data-ee-filter-input]")) {
          if (main) main.classList.add("is-loading");
          form.submit();
        }
      });
    }

    var sort = document.querySelector("[data-ee-sort]");
    if (sort && !sort.dataset.eeBound) {
      sort.dataset.eeBound = "1";
      sort.addEventListener("change", function () {
        if (main) main.classList.add("is-loading");
        sort.form.submit();
      });
    }

    // Mobile filter drawer
    var panel = document.querySelector("[data-ee-filters]");
    var veil = document.querySelector(".ee-filters__veil");
    function setOpen(on) {
      if (!panel) return;
      panel.classList.toggle("is-open", on);
      if (veil) veil.classList.toggle("is-open", on);
      document.body.style.overflow = on ? "hidden" : "";
    }
    document.querySelectorAll("[data-ee-filters-open]").forEach(function (b) {
      if (b.dataset.eeBound) return;
      b.dataset.eeBound = "1";
      b.addEventListener("click", function () { setOpen(true); });
    });
    document.querySelectorAll("[data-ee-filters-close]").forEach(function (b) {
      if (b.dataset.eeBound) return;
      b.dataset.eeBound = "1";
      b.addEventListener("click", function () { setOpen(false); });
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") setOpen(false);
    });
  }

  /* ---------- Live search (predictive, no button press needed) ---------- */
  function initLiveSearch() {
    var input = document.querySelector("[data-ee-live-search]");
    var box = document.querySelector("[data-ee-live-results]");
    if (!input || !box) return;
    var serverResults = document.querySelector("[data-ee-server-results]");
    var timer = null;

    function card(p) {
      var img = p.featured_image && p.featured_image.url ? safeUrl(p.featured_image.url) : "";
      return '<a class="ee-card" href="' + esc(safeUrl(p.url)) + '">' +
        (img ? '<span class="ee-card__media"><img src="' + esc(img) + '" alt="" loading="lazy"></span>' : "") +
        '<span class="ee-card__info">' +
        '<span class="ee-card__title">' + esc(p.title) + "</span>" +
        '<span class="ee-price"><span>' + esc(box.dataset.currency || "") + esc(p.price) + "</span></span>" +
        "</span></a>";
    }

    input.addEventListener("input", function () {
      clearTimeout(timer);
      var q = input.value.trim();
      if (q.length < 2) {
        box.innerHTML = "";
        if (serverResults) serverResults.style.display = "";
        return;
      }
      timer = setTimeout(function () {
        fetch("/search/suggest.json?q=" + encodeURIComponent(q) +
          "&resources[type]=product&resources[limit]=10&resources[options][unavailable_products]=last")
          .then(function (r) { return r.json(); })
          .then(function (d) {
            var prods = (d.resources && d.resources.results && d.resources.results.products) || [];
            if (serverResults) serverResults.style.display = "none";
            box.innerHTML = prods.length
              ? prods.map(card).join("")
              : '<p class="ee-live-empty">No products found for &ldquo;' + q.replace(/</g, "&lt;") + '&rdquo;</p>';
          })
          .catch(function () {});
      }, 250);
    });
  }

  /* ---------- Buy it now (product page) ---------- */
  function initBuyNow() {
    var btn = document.querySelector("[data-ee-buy-now]");
    if (!btn) return;

    var wrap = btn.closest(".ee-buy") || document;

    function dynamicPresent() {
      var dyn = wrap.querySelector(".shopify-payment-button__button");
      return !!(dyn && dyn.offsetParent !== null);
    }
    function showFallback() { btn.classList.add("ee-buy-now--on"); }
    function hideFallback() { btn.classList.remove("ee-buy-now--on"); }

    if (btn.dataset.eeNoDynamic) {
      // Dynamic checkout is switched off in the section settings, so Shopify
      // will never render its button. Show ours immediately, no waiting.
      showFallback();
    } else {
      // Watch the buy-button area. The fallback stays hidden (CSS default)
      // until we are confident Shopify's own button did not render, and it is
      // hidden again the moment Shopify's button turns up late — so the two
      // can never be on screen together.
      var settled = false;
      var timer = setTimeout(function () {
        settled = true;
        if (!dynamicPresent()) showFallback();
      }, 900);

      if (window.MutationObserver) {
        var obs = new MutationObserver(function () {
          if (dynamicPresent()) {
            hideFallback();
            clearTimeout(timer);
            obs.disconnect();
          } else if (settled) {
            showFallback();
          }
        });
        obs.observe(wrap === document ? document.body : wrap, { childList: true, subtree: true });
        setTimeout(function () { obs.disconnect(); }, 6000);
      }
    }

    btn.addEventListener("click", function () {
      var form = document.getElementById("ee-product-form");
      if (!form) return;
      var idInput = form.querySelector('[name="id"]');
      // If nothing valid is selected (the current option combination has no
      // real variant), the id field is intentionally left blank by the
      // product-page script — bail out instead of checking out whatever id
      // happened to be there before.
      if (!idInput || !idInput.value) return;
      var qtyInput = form.querySelector('[name="quantity"]');
      btn.disabled = true;
      btn.textContent = "One moment…";
      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", "Accept": "application/json" },
        body: JSON.stringify({
          id: parseInt(idInput.value, 10),
          quantity: qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1
        })
      })
        .then(function (r) {
          if (!r.ok) throw new Error("add failed");
          window.location.href = "/checkout";
        })
        .catch(function () {
          btn.disabled = false;
          btn.textContent = "Buy it now";
          // Last resort: native add-to-cart submit, then the cart page.
          form.submit();
        });
    });
  }

  /* ---------- Cart checkout (robust) ---------- */
  function initCheckout() {
    var btn = document.querySelector("[data-ee-checkout]");
    if (!btn) return;
    btn.addEventListener("click", function (e) {
      e.preventDefault();
      var form = document.getElementById("ee-cart-form");
      var updates = [];
      if (form) {
        form.querySelectorAll('input[name="updates[]"]').forEach(function (i) {
          updates.push(parseInt(i.value, 10) || 0);
        });
      }
      btn.disabled = true;
      btn.textContent = "One moment…";
      fetch("/cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", "Accept": "application/json" },
        body: JSON.stringify({ updates: updates })
      })
        .then(function () { window.location.href = "/checkout"; })
        .catch(function () { window.location.href = "/checkout"; });
    });
  }

  function init() {
    initNav();
    initMobileMenu();
    initThemeToggle();
    initStickyHeader();
    initWishlist();
    initWishDrawer();
    initFilters();
    initLiveSearch();
    initBuyNow();
    initCheckout();
    initReveals();
    initScrollFilm();
    initTables();
    initGallery();
    initQty();
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();

  document.addEventListener("shopify:section:load", init);
})();
